import React, { useEffect } from 'react';
import './styles/DraftLeague.css';
import { Link } from 'react-router-dom';
import basketballImg from './assets/basketball.png';
import pic1 from './assets/DL_pic1.jpeg';
//import pic2 from './assets/DL_pic2.jpeg'; // Add your other images
import pic3 from './assets/DL_pic3.jpeg';
import pic4 from './assets/DL_pic4.jpeg';

const About = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--basketball-image',
      `url(${basketballImg})`
    );
  }, []);

  return (
    <div className="hero">
      {/* Background */}
      <div className="hero-background" />
      <div className="hero-overlay" />

      {/* Floating elements */}
      <div className="floating-element-1" />
      <div className="floating-element-2" />
      <div className="floating-element-3" />

      {/* Main Content */}
      <div className="hero-content">
        <Link to="/" className="hero-link">
          <h1 className="hero-title">
            Grass Valley
            <br />
            <span className="hero-title-bold">Draft League</span>
          </h1>
        </Link>

        {/* About the League Sections */}
        <div className="about-sections">
          {/* What is Draft League */}
          <div className="about-section">
            <div className="about-content">
              <div className="about-text">
                <h2 className="about-title">What is Draft League?</h2>
                <p className="about-description">
                  Draft League Basketball is a competitive basketball for
                  players age 15 to 65. Teams are formed through a live draft on
                  "Draft Night". Players register individually and are drafted
                  by team captains, this ensures balanced teams and a
                  competitive atmosphere. Our league focuses on mentorship,
                  skill development, sportsmanship, and building community
                  through basketball.
                </p>
                <ul className="about-features">
                  <li>Live draft creates balanced teams</li>
                  <li>All skill levels welcome</li>
                  <li>Professional referees and scorekeeping</li>
                  <li>8 game regular season + playoffs</li>
                </ul>
              </div>
              <div className="about-image">
                <img src={pic4} alt="Draft Night" className="section-image" />
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div className="about-section alternate">
            <div className="about-content">
              <div className="about-image">
                <img src={pic1} alt="Game Action" className="section-image" />
              </div>
              <div className="about-text">
                <h2 className="about-title">How It Works</h2>
                <div className="steps-container">
                  <div className="step">
                    <div className="step-number">1</div>
                    <div className="step-text">
                      <h4>Register</h4>
                      <p>
                        Sign up as an individual player. No need to build your
                        own team!
                      </p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-number">2</div>
                    <div className="step-text">
                      <h4>Draft Night</h4>
                      <p>
                        Team captains use a snake draft format to create
                        balanced teams.
                      </p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-number">3</div>
                    <div className="step-text">
                      <h4>Play Ball</h4>
                      <p>
                        Compete in 8 weeks of games plus playoffs for top
                        teams.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Community Impact */}
          <div className="about-section">
            <div className="about-content">
              <div className="about-text">
                <h2 className="about-title">Building Community</h2>
                <p className="about-description">
                  Draft League is more than basketball - it's about supporting
                  youth development and a positive community culture. Our league
                  creates lasting friendships, mentorship opportunities, and
                  positive community impact. We're proud to be sponsored by{' '}
                  <a href="https://www.boystomennorcal.org">
                    Boys to Men NorCal
                  </a>
                  , supporting youth development in our community.
                </p>
                <div className="community-stats">
                  <div className="stat">
                    <div className="stat-number">250+</div>
                    <div className="stat-label">Players Served</div>
                  </div>
                  <div className="stat">
                    <div className="stat-number">3</div>
                    <div className="stat-label">Years Running</div>
                  </div>
                  <div className="stat">
                    <div className="stat-number">$5000+</div>
                    <div className="stat-label">Raised for Youth Programs</div>
                  </div>
                </div>
              </div>
              <div className="about-image">
                <img
                  src={pic3}
                  alt="League Community"
                  className="section-image"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cards-container">
          <Link
            to="/"
            className="card-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="card">
              <h3 className="card-title">Home</h3>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
